import Base from "./Base"

export default {
  httpBaseUri: "https://test-api.operandiodev.com",
  httpServiceBaseUri: "https://test-api.operandiodev.com/graphql",
  wsServiceBaseUri: "wss://test-api.operandiodev.com/graphql",

  clientKiosk: false,

  showConfigInTitle: true,
  configTitle: "[TEST]",

  theme: {
    ...Base.theme,

    logoContainer: "images-dev"
  },

  uploader: {
    ...Base.uploader,

    imageViewerBaseUri: "https://d2y50qvg2q46in.cloudfront.net",
    imageViewerBucketName: "dev-operandio-content-ap-southeast-2",

    videoViewerBaseUri: "https://dev-video.operandiodev.com",
    videoViewerBucketName: "dev-operandio-content-ap-southeast-2",

    scormUploadBucketName: "dev-operandio-scorm-quarantine",
    scormViewerBaseUri: "https://dev-scorm.operandiodev.com"
  },

  services: {
    ...Base.services,
    export: {
      ...Base.services.export,
      jobUrl: "https://lxknk3pfv9.execute-api.ap-southeast-2.amazonaws.com/prod/job/", // DEV account
      auditUrl: "https://lxknk3pfv9.execute-api.ap-southeast-2.amazonaws.com/prod/auditscores/" // DEV account
    }
  },

  errors: {
    ...Base.errors,

    showDetail: true,
    showGraphQLErrorNotification: true
  }
}
